import { i18n } from '@/plugins/i18n'

export const allotmentType = {
    normal:         1,
    allotmentToPf:  2,
    directDebit:    3,
};

export const allotmentTypeStr = {
    normal:          i18n.t('allotment_type.normal'),
    allotmentToPf:   i18n.t('allotment_type.allotment_to_pf'),
    directDebit:     i18n.t('allotment_type.direct_debit'),

    get(type) {
        let type_str = null;

        Object.keys(allotmentType).forEach(item => {
            if(allotmentType[item] === type) {
                type_str = allotmentTypeStr[item];
            }
        });

        return type_str;
    }
};

export const allotments=[
    {
        name: allotmentTypeStr.allotmentToPf,
        value: allotmentType.allotmentToPf
    },
    {
        name: allotmentTypeStr.directDebit,
        value: allotmentType.directDebit
    },
    {
        name: allotmentTypeStr.normal,
        value: allotmentType.normal
    },
];